import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import theme from "./theme/theme";
import HomePage from "./pages/HomePage";
import Login from "./pages/auth/LoginPage";
import Register from "./pages/auth/RegisterPage";
import VerifyEmailPage from "./pages/auth/VerifyEmailPage";
import VerifyEmailConfirmPage from "./pages/auth/VerifyEmailConfirmPage";
import VerifyEmailChangePage from "./pages/auth/VerifyEmailChangePage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import {
  ABOUT_ROUTE_PATH,
  CATEGORIES_ROUTE_PATH,
  EXPENSES_ROUTE_PATH,
  HOME_ROUTE_PATH,
  INCOMES_ROUTE_PATH,
  LOGIN_ROUTE_PATH,
  MONTHLY_REPORTS_ROUTE_PATH,
  REGISTER_ROUTE_PATH,
  USER_PROFILE_ROUTE_PATH,
  VERIFY_EMAIL_ROUTE_PATH,
  VERIFY_EMAIL_CONFIRM_ROUTE_PATH,
  FORGOT_PASSWORD_ROUTE_PATH,
  RESET_PASSWORD_ROUTE_PATH,
  VERIFY_EMAIL_CHANGE_ROUTE_PATH,
  CONTACT_ROUTE_PATH,
} from "./utils/constants/AppConstants";
import UserProfilePage from "./pages/user/UserProfilePage";
import IncomePage from "./pages/finances/IncomePage";
import ExpensePage from "./pages/finances/ExpensePage";
import Layout from "./pages/layout/Layout";
import CategoryPage from "./pages/category/CategoryPage";
import MonthlyReportsPage from "./pages/finances/reports/MonthlyReportsPage";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import AboutPage from "./pages/AboutPage";
import FeedbackPage from "./pages/FeedbackPage";
import { AuthProvider } from "./auth/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { UserProfileProvider } from "./contexts/ProfileContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        if (error?.status >= 400 && error?.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: (failureCount, error: any) => {
        if (error?.status >= 400 && error?.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UserProfileProvider>
            <CurrencyProvider>
              <Routes>
                <Route element={<Layout />}>
                  <Route path={HOME_ROUTE_PATH} element={<HomePage />} />
                  <Route path={ABOUT_ROUTE_PATH} element={<AboutPage />} />
                  <Route path={EXPENSES_ROUTE_PATH} element={<ExpensePage />} />
                  <Route path={INCOMES_ROUTE_PATH} element={<IncomePage />} />
                  <Route path={CATEGORIES_ROUTE_PATH} element={<CategoryPage />} />
                  <Route path={MONTHLY_REPORTS_ROUTE_PATH} element={<MonthlyReportsPage />} />
                  <Route path={USER_PROFILE_ROUTE_PATH} element={<UserProfilePage />} />
                  <Route path={CONTACT_ROUTE_PATH} element={<FeedbackPage />} />
                </Route>
                <Route path={LOGIN_ROUTE_PATH} element={<Login />} />
                <Route path={REGISTER_ROUTE_PATH} element={<Register />} />
                <Route path={VERIFY_EMAIL_ROUTE_PATH} element={<VerifyEmailPage />} />
                <Route path={VERIFY_EMAIL_CONFIRM_ROUTE_PATH} element={<VerifyEmailConfirmPage />} />
                <Route path={FORGOT_PASSWORD_ROUTE_PATH} element={<ForgotPasswordPage />} />
                <Route path={RESET_PASSWORD_ROUTE_PATH} element={<ResetPasswordPage />} />
                <Route path={VERIFY_EMAIL_CHANGE_ROUTE_PATH} element={<VerifyEmailChangePage />} />
              </Routes>
            </CurrencyProvider>
          </UserProfileProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
